import { SUSPENSE_COMPETITOR, SUSPENSE_REASON } from '../../../../../../views/billing/subscription/constants';

export default {
  title: 'Facturare automată',
  buttons: {
    add_subscription: 'Adaugă abonament',
    suspend_company: 'Suspendă restaurantul',
    restore_company: 'Restaurează restaurantul',
    edit_suspend: 'Editează info suspendare',
    confirm: 'Confirmă',
    cancel: 'Anulează',
  },
  modals: {
    suspend_company: {
      title: 'Sigur doriți să suspendați {{company}}?',
      description:
        'Aceasta va anula toate abonamentele active, va dezactiva comenzile live și va notifica proprietarul restaurantului prin e-mail. Selectați un motiv înainte de confirmare.',
      suspense_reason: {
        label: 'Selectați motivul suspendării',
        placeholder: 'Alegeți un motiv',
        options: {
          [SUSPENSE_REASON.ClosedOrOwnershipChange]: 'Închis sau schimbare de proprietar',
          [SUSPENSE_REASON.LowRoi]: 'ROI scăzut',
          [SUSPENSE_REASON.PricingFeesSensitivity]: 'Sensibilitate la prețuri/comisioane',
          [SUSPENSE_REASON.MissingIntegrationsProductGaps]: 'Integrări lipsă/lipsuri de produs',
          [SUSPENSE_REASON.PoorOnboardingActivation]: 'Onboarding/activare deficitar(ă)',
          [SUSPENSE_REASON.SupportDissatisfaction]: 'Nemulțumire față de suport',
          [SUSPENSE_REASON.SwitchedToCompetitor]: 'Schimbat cu competitor/marketplace/DIY',
          [SUSPENSE_REASON.MarketingPerformanceDisappointment]: 'Dezamăgire privind performanța de marketing',
          [SUSPENSE_REASON.WrongRegistrationData]: 'Înregistrare/date incorecte',
        },
        validation: {
          required: 'Vă rugăm să alegeți un motiv',
        },
      },
      suspense_competitor: {
        label: 'Cu ce competitor au trecut?',
        placeholder: 'Vă rugăm să alegeți un competitor',
        options: {
          [SUSPENSE_COMPETITOR.Allo]: 'Allo',
          [SUSPENSE_COMPETITOR.Sides]: 'Slice',
          [SUSPENSE_COMPETITOR.Ordersmart]: 'Ordersmart',
          [SUSPENSE_COMPETITOR.RobinCook]: 'Robin Cook',
          [SUSPENSE_COMPETITOR.Lightspeed]: 'Lightspeed',
          [SUSPENSE_COMPETITOR.GastroMaster]: 'Gastro Master',
          [SUSPENSE_COMPETITOR.Dish]: 'Dish',
          [SUSPENSE_COMPETITOR.Other]: 'Altul',
        },
        validation: {
          required: 'Vă rugăm să alegeți un competitor',
        },
      },
      suspense_reason_notes: {
        label: 'Context suplimentar (opțional)',
        placeholder: 'Furnizați detalii suplimentare',
      },
    },
    restore_company: {
      title: 'Sigur doriți să restaurați {{company}}?',
      description: 'Va trebui să creați manual abonamentul și să activați comenzile live.',
    },
  },
  toasts: {
    failed_to_load_data: 'Eroare la încărcarea detaliilor abonamentului',
    failed_to_suspend_company: 'Eroare la suspendarea restaurantului. Contactați suportul tehnic',
    failed_to_restore_company: 'Eroare la restaurarea restaurantului. Contactați suportul tehnic',
  },
};
